'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InitialState = {
  speed: 100,
  direction: 'right',
  size: 10,
  position: [[6, 4], [5, 4], [4, 4]],
  gameOver: false,
  apple: [0, 0]
};

var Snake = function (_Component) {
  (0, _inherits3.default)(Snake, _Component);

  function Snake(props) {
    (0, _classCallCheck3.default)(this, Snake);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Snake.__proto__ || (0, _getPrototypeOf2.default)(Snake)).call(this, props));

    _this.getContainerSize = function () {
      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height;

      return {
        width: width || window.innerWidth,
        height: height || window.innerHeight
      };
    };

    _this.setPosition = function (direction, lastPosition) {
      var size = _this.getContainerSize();
      var surfaceWidth = parseInt(size.width / _this.state.size, 10);
      var surfaceHeight = parseInt(size.height / _this.state.size, 10);

      switch (direction) {
        case 'left':
          if (lastPosition[0] - 1 === -1) {
            return [surfaceWidth, lastPosition[1]];
          }
          return [lastPosition[0] - 1, lastPosition[1]];
        case 'up':
          if (lastPosition[1] - 1 === -1) {
            return [lastPosition[0], surfaceHeight];
          }
          return [lastPosition[0], lastPosition[1] - 1];
        case 'right':
          if (lastPosition[0] + 1 > surfaceWidth) {
            return [0, lastPosition[1]];
          }
          return [lastPosition[0] + 1, lastPosition[1]];
        case 'down':
          if (lastPosition[1] + 1 > surfaceHeight) {
            return [lastPosition[0], 0];
          }
          return [lastPosition[0], lastPosition[1] + 1];
        default:
          return lastPosition;
      }
    };

    _this.init = function () {
      _this.focusInput();
      _this.setState((0, _extends3.default)({}, InitialState, {
        apple: _this.generateApplePosition()
      }));

      _this.interval = setInterval(_this.gameLoop, _this.state.speed);
    };

    _this.handleKeyDown = function (event) {
      event.preventDefault();
      var keys = {
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down'
      };

      var direction = keys[event.which];
      if (direction) {
        if (_this.state.direction === 'left' && direction === 'right' || _this.state.direction === 'up' && direction === 'down' || _this.state.direction === 'right' && direction === 'left' || _this.state.direction === 'down' && direction === 'up') {
          return;
        }
        _this.setState((0, _extends3.default)({}, _this.state, { direction: direction }));
      }
    };

    _this.focusInput = function () {
      _this.refs.input.focus();
    };

    _this.drawApple = function () {
      var _this$state = _this.state,
          size = _this$state.size,
          apple = _this$state.apple;


      _this._context.save();
      _this._context.fillStyle = '#6DC983';
      _this._context.beginPath();
      var radius = size / 2;
      var x = apple[0] * size + radius;
      var y = apple[1] * size + radius;
      _this._context.arc(x, y, radius, 0, Math.PI * 2, true);
      _this._context.fill();
      _this._context.restore();
    };

    _this.drawElement = function (position) {
      var size = _this.state.size;


      var x = size * position[0];
      var y = size * position[1];
      _this._context.fillRect(x, y, size, size);
    };

    _this.drawSnake = function () {
      var position = _this.state.position;


      _this._context.save();
      _this._context.fillStyle = '#7377CF';

      position.forEach(_this.drawElement);

      _this._context.restore();
    };

    _this.generateApplePosition = function () {
      var size = _this.getContainerSize();
      var surfaceWidth = parseInt(size.width / _this.state.size, 10);
      var surfaceHeight = parseInt(size.height / _this.state.size, 10);

      return [Math.floor(Math.random() * surfaceWidth), Math.floor(Math.random() * surfaceHeight)];
    };

    _this.advance = function () {
      var direction = _this.state.direction;

      var position = _this.state.position.slice(0, _this.state.position.length - 1);
      var currentPosition = _this.state.position[0];
      var newPosition = _this.setPosition(direction, currentPosition);

      if (_lodash2.default.isEqual(currentPosition, _this.state.apple)) {
        _this.setState((0, _extends3.default)({}, _this.state, {
          apple: _this.generateApplePosition(),
          position: [newPosition].concat((0, _toConsumableArray3.default)(_this.state.position))
        }));
      } else {
        position.forEach(function (element) {
          if (_lodash2.default.isEqual(newPosition, element)) {
            _this.setState((0, _extends3.default)({}, _this.state, { gameOver: true }));
          }
        });
        _this.setState((0, _extends3.default)({}, _this.state, { position: [newPosition].concat((0, _toConsumableArray3.default)(position)) }));
      }
    };

    _this.gameLoop = function () {
      var size = _this.getContainerSize();
      var surfaceWidth = parseInt(size.width, 10);
      var surfaceHeight = parseInt(size.height, 10);

      _this._context.clearRect(0, 0, surfaceWidth, surfaceHeight);
      _this.advance();
      _this.drawSnake();
      _this.drawApple();

      if (_this.state.gameOver) {
        clearInterval(_this.interval);
      }
    };

    _this.state = InitialState;
    return _this;
  }

  (0, _createClass3.default)(Snake, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._context = this.refs.canvas.getContext('2d');
      this.init();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'render',
    value: function render() {
      var size = this.getContainerSize();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', { style: { position: 'absolute', width: 0, height: 0, outline: '0 !important', border: 'none' }, ref: 'input', type: 'text', onKeyDown: this.handleKeyDown }),
        this.state.gameOver && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            'GAME OVER'
          ),
          _react2.default.createElement(
            'div',
            { onClick: this.init },
            'Reset'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Score: ',
            this.state.position.length,
            ' '
          )
        ),
        _react2.default.createElement('canvas', {
          ref: 'canvas',
          onKeyDown: this.handleKeyDown,
          onClick: this.focusInput,
          width: size.width,
          height: size.height
        })
      );
    }
  }]);
  return Snake;
}(_react.Component);

exports.default = Snake;